const SET_SNACKBAR = 'SET_SNACKBAR'

const state = {
  data: {
    snackbar: {},
  },
}

const getters = {
  snackbar: (state) => state.data.snackbar,
}

const actions = {
  setSnackbar(context, { message = 'Ops! ocorreu um erro.', color = 'secondary', status = true }) {
    context.commit(SET_SNACKBAR, { message, color, status })
  },
}

const mutations = {
  [SET_SNACKBAR](state, payload) {
    state.data.snackbar = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
